export default "__VITE_ASSET__c941658b__"